<template>
  <span
    v-if="!isColorful"
    :class="'icon-' + icon"
    :style="size != null ? `font-size: ${size}px` : ''"
  />
  <span
    v-else
    :class="'icon-' + icon"
    :style="size != null ? `font-size: ${size}px` : ''"
  >
    <span
      v-for="index in numberOfColors"
      :key="index"
      :class="'icon-' + icon + ' path' + index"
    />
  </span>
</template>

<script>

export default {
  props: {
    icon: {
      type: String,
      default: 'box'
    },
    size: {
      type: String,
      default: null
    },
    isColorful: {
      type: Boolean,
      default: false
    },
    numberOfColors: {
      type: Number,
      default: 0
    }
  }
}
</script>
<style src="@/assets/kaledo-icons/icons.css">



// WEBPACK FOOTER //
// src/components/KaledoComponents/KIcon.vue